import {styled, Box} from 'external/material'
import {centerVertically} from 'utils/style'
import Lessons from './Lessons'

const StyledLessons = styled(Box)(lessonsStyles)
export default function LessonsPage() {
  return (
    <StyledLessons className="container">
        <Lessons />
    </StyledLessons>
  )
}

function lessonsStyles() {
  return {
    "& .lessons": {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      overflowY: 'hidden',
      backgroundColor: '#fff',
      borderRadius: 5,
      transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      boxShadow: 'rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px',
      "& .nameCell": {
        display: 'flex'
      },
      "& .lessonName": {
        marginLeft: 10,
        color: '#6b748c',
        fontSize: '13pt',
        ...centerVertically,
        "&.downloaded": {
          fontWeight: 500
        }
      },
      "& .lessonIcon": {
        color: '#d6e3f1',
        ...centerVertically,
        "&.downloaded": {
          color: '#ff47cb'
        }
      },
      "& .lessonLinks": {
        display: 'flex',
        "& .lessonLink": {
          marginLeft: 25
        }
      }
    },
    "& .MuiTableBody-root": {
      "& .MuiTableRow-root": {
        "&:nth-of-type(odd)": {
          backgroundColor: '#f8fbfd'
        },
        "& .MuiTableCell-root": {
          color: '#4d5874',
          borderBottom: 0,
        }
      }
    }
  }
}
